<div class="container">
    <div class="attachments-section m-16:v md:m-24:v">
        @for (document of documents(); track document.id) {
            <app-attached-file-list-item
                [fileAttachment]="document"
                [insuranceTypeId]="insuranceTypeId()"
            ></app-attached-file-list-item>
        } @empty {
            <p class="m-32:t m-64:b align:c">Es wurden noch keine Dokumente hinzugefügt.</p>
        }
    </div>
    <div class="upload-section">
        <input
            id="file-select-button"
            type="file"
            ctrlFileSelect
            [accept]="['image/png', 'image/jpeg', 'application/pdf']"
            maxFileSize="10240"
            multiple
            (filesSelected)="handleFilesSelected($event)"
            (filesRejected)="handleFilesRejected($event)"
        />
        <label
            for="file-select-button"
            class="-blue file-select-button fs:m"
            ><i ctrlIcon="add"></i>{{ documents().length > 0 ? 'weitere ' : ' ' }} Dateien auswählen
        </label>
        <p class="fs:xs fw:semibold m-8:t m-0:b align:center md:align:right">JPEG, PNG oder PDF</p>
    </div>
</div>
